import * as React from 'react';

export default class NumberSpinner extends React.Component<
    {
        value?: number;

        onChange(value: number);
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    handleChange = (value) => {
        let parsed;

        if (typeof value === 'string') {
            parsed = parseInt(value);
        } else {
            parsed = value;
        }

        if (value != null) {
            if (value === '') {
                value = null;
            } else if (!isNaN(parsed) && parsed > 0) {
                value = parsed;
            } else {
                return;
            }
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    //LL: 14.03.19: input type=number
    handleChange_InputTypeNumber = (e) => {
        const value = e.target.value;
        this.handleChange(value);
    };

    render() {
        const value = this.props.value != null ? this.props.value.toString() : '';

        //LL: 14.03.19: input type=number
        //    <INPUT TYPE="NUMBER" MIN="0" MAX="10" STEP="2" VALUE="6" SIZE="6">
        //    https://developer.mozilla.org/ru/docs/Web/HTML/Element/Input/number      <=========

        //LL: onChange={ () => { } } //Is added to fix red warning.

        //min={ 0 }
        //max={ 10 }
        //step={ 2 }

        let step = 1;

        return (
            <div className="number-spinner">
                <div className="input-number">
                    <input
                        className="form-control"
                        type="number"
                        value={value}
                        step={step}
                        onInput={this.handleChange_InputTypeNumber}
                        onChange={() => {}}
                    />
                </div>
            </div>
        );
    }
}
